const initFadeInAnimations = () => {
    const elementsToAnimate = document.querySelectorAll("[data-animation]");
    //instance new observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add("active");
                }, 400);
            }
        });
    });
    //observe
    elementsToAnimate.forEach((element) => {
        observer.observe(element);
    });
};
